import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import InfoIcon from '@mui/icons-material/Info';
import { useGetCompaniesQuery } from '../../Companies/Service/companiesApi';
import EntityFormLayout from '../../Shared/Components/EntityFormLayout/EntityFormLayout';
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';
import { FormRenderGroupTypes } from '../../Shared/Components/FormRenderer/FormRenderGroup.types';
import { BankAccountsRoutes } from '../../../Router/path';
import { bankAccountFields } from '../fields';
import { useCreateBankAccountMutation } from '../Service/bankAccountsApi';
import { BankAccount } from '../Types/bankAccountTypes';

const emptyBankAccount: BankAccount = {
    id: 0,
    companyId: 0,
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    swift: '',
    currency: '',
    description: '',
};

const EditBankAccount = () => {
    const [createBankAccount, createStatus] = useCreateBankAccountMutation();
    const {
        data: allCompanies,
        isLoading: isAllCompaniesLoading,
        isError: isAllCompaniesError,
    } = useGetCompaniesQuery();

    const companyOptions =
        allCompanies?.map((company) => ({
            label: company.name,
            value: company.id,
        })) ?? [];

    const fields = bankAccountFields.map((field) =>
        field.name === 'companyId'
            ? {
                    ...field,
                    options: companyOptions,
              }
            : field
    );

    const entityForm = useEntityForm<BankAccount>({
        initialData: emptyBankAccount,
        fields,
        submitFn: (data) =>
            createBankAccount({
                ...data,
                companyId: Number(data.companyId),
            }).unwrap(),
        redirectUrl: BankAccountsRoutes.root,
        title: 'Dodaj konto bankowe',
        icon: <AccountBalanceIcon />,
        backUrl: BankAccountsRoutes.root,
        groupOrder: [FormRenderGroupTypes.basic],
        groupIcons: {
            Podstawowe: <InfoIcon />,
        },
        mutationStatus: createStatus,
    });

    if (isAllCompaniesLoading) {
        return (
            <Typography align="center" sx={{ mt: 4 }}>
                <CircularProgress />
            </Typography>
        );
    }

    if (isAllCompaniesError) {
        return (
            <Typography color="error" align="center" sx={{ mt: 4 }}>
                Nie udało się załadować listy firm.
            </Typography>
        );
    }

    if (!companyOptions.length) {
        return (
            <Typography color="warning.main" align="center" sx={{ mt: 4 }}>
                Przed dodaniem konta bankowego musisz mieć co najmniej jedną firmę.
            </Typography>
        );
    }

    return <EntityFormLayout {...entityForm} />;
};

export default EditBankAccount;